import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getWinnersData } from "../redux/slices/winnersSlice";

const Overlay = ({ countdown, showCountdown, isJackpot }) => {
  const [showImage, setShowImage] = useState(false);
  const [animateImage, setAnimateImage] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_id = localStorage.getItem("userID");

  const { winners } = useSelector((state) => state.winners);

  // Check if the current user_id matches any winner's user_id
  const isUserWinner = winners.some(
    (winner) => winner.user_id.toString() === user_id
  );

  useEffect(() => {
    if (countdown === 9) {
      dispatch(getWinnersData());
    }
  }, [countdown, dispatch]);
  

  useEffect(() => {
    if (countdown === 0) {
      if (isUserWinner && isJackpot) {
        setShowImage(true);

        // Start animation after 2 seconds
        setTimeout(() => {
          setAnimateImage(true);
        }, 2000);

        // Navigate after 5 seconds
        setTimeout(() => {
          setShowImage(false);
          navigate("/result");
        }, 5000);
      } else if (!isUserWinner) {
        navigate("/result"); // Navigate instantly after countdown
      }
    }
  }, [countdown, isJackpot, isUserWinner, navigate]);

  return (
    <div className="absolute top-[26%] lg:top-[37%] left-0 w-full h-[102%] lg:h-[140%] bg-[rgba(217,217,217,0.36)] backdrop-blur-sm z-10">
      {showCountdown ? (
        <div className="text-center mt-48">
          {countdown > 0 && (
            <div className="relative flex items-center justify-center w-40 h-40 mx-auto bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 rounded-full shadow-lg">
              <h1 className="text-white text-5xl font-extrabold animate-pulse">
                {countdown}
              </h1>
              <div className="absolute top-0 left-0 w-full h-full border-4 border-white rounded-full animate-spin-slow"></div>
            </div>
          )}

          {showImage && (
            <img
              src="/images/jackpot.png"
              alt="Jackpot"
              className={`w-[200px] h-[100px] mx-auto mt-4 transition-all duration-[4000ms] ease-in-out ${
                animateImage
                  ? "transform -translate-y-[500px] opacity-0"
                  : "opacity-100"
              }`}
            />
          )}
        </div>
      ) : (
        <div className="w-full flex flex-col items-center mt-4">
          <img
            src="/images/comingSoon.png"
            alt="Coming Soon"
            className="object-contain mb-5 max-w-full h-auto"
          />
        </div>
      )}
    </div>
  );
};

export default Overlay;
